import React from 'react';
import { downloadBillingCycleInvoicePdf } from '../../services/api';
import { useBillingPdfDownload } from '../../hooks/useBillingPdfDownload';
import { BillingPdfMenuRow } from './BillingPdfMenuRow';

/** A download-menu row that opens the cycle's invoice PDF. */
export const BillingCycleInvoiceDownloadButton: React.FC<{
  billingCycleId: string;
}> = ({ billingCycleId }) => {
  const { isDownloading, download } = useBillingPdfDownload(
    () =>
      downloadBillingCycleInvoicePdf({
        path: { billing_cycle_id: billingCycleId },
        responseType: 'blob',
      }),
    { failureTitle: 'Failed to generate invoice', logLabel: 'invoice PDF' }
  );

  return (
    <BillingPdfMenuRow
      label='Print Invoice'
      title='Open a printable invoice (PDF)'
      isDownloading={isDownloading}
      onClick={() => void download()}
    />
  );
};
